export default __webpack_public_path__ + "static/media/m.test.abf3d1d9.png";